export default __webpack_public_path__ + "static/media/course5.ac7e8c69.webp";